export default __webpack_public_path__ + "static/media/murder-mystery.d4e955f3.mp4";